module.exports = __webpack_public_path__ + "assets/addonmixedfleet.ae2e50df.svg";